import React from 'react';
import {
    CreateButton, Datagrid, Edit, List, ReferenceArrayInput, SelectArrayInput, ShowGuesser, SimpleForm, TextField,
    TextInput, TopToolbar
} from 'react-admin';

// No create view on purpose: "Create" opens /roles/create in the edit view, the backend answers GetOne/create with an
// empty role and saves it under the typed name (PUT /roles/create, the id comes from the body).
const RoleList: React.FC = () => (
    <List actions={<TopToolbar><CreateButton /></TopToolbar>} perPage={100}>
        <Datagrid rowClick="edit" bulkActionButtons={false}>
            <TextField source="name" />
        </Datagrid>
    </List>
);

// A permission is one feature's permission set, serialized (GET /features from the apps).
const RoleEdit: React.FC = () => (
    <Edit mutationMode="pessimistic">
        <SimpleForm>
            <TextInput label="Name" source="id" required />
            <ReferenceArrayInput label="Features" source="permissions" reference="features" perPage={1000}>
                <SelectArrayInput label="Features" optionText="id" optionValue="permissions" sx={{ minWidth: 400 }} />
            </ReferenceArrayInput>
        </SimpleForm>
    </Edit>
);

export const roles = {
    list: RoleList,
    edit: RoleEdit,
    show: ShowGuesser
};
